module.exports = __webpack_public_path__ + "img/acupuncture.e31b1c73.png";